import React from "react";
import { ItemMainMenu } from "./itemMainMenu";
import { Logo } from "./logo";

export function MainMenu(): JSX.Element {
  return (
    <div className="menuRow">
      <div className="menuLogo">
        <Logo />
      </div>
      <div className="menuTitle">Weightlifting app reviews</div>

      <div className="menuItems">
        <ItemMainMenu name="About" />
        <ItemMainMenu name="Reviews" />
        <ItemMainMenu name="Comparison" />
      </div>
    </div>
  );
}
